/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeviceChooser/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DeviceChooser({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/DeviceChooser",
  preview,
  handleClear
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let videoCaptureValueData = fromData.useDataValue({ viewPath,
context: 'videoCapture',
})
let aggregateData = fromHelpers.shouldShowContent(videoCaptureValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 preview={preview}
 handleClear={handleClear}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}